import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomModalComponent } from 'src/app/components/ui/custom-modal/custom-modal.component';
import { DeviceService } from 'src/app/services/devices/device.service';
import { isAncFamilyDevice } from 'src/app/services/devices/device-type.util';
import { ModalService } from 'src/app/services/modal/modal.service';
import { UserService } from 'src/app/services/user/user.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-admin-search',
    templateUrl: './admin-search.component.html',
    standalone: false
})
export class AdminSearchComponent {

  userSearch: string = '';
  serialSearch: string = '';

  userVerificationField: string = '';

  resultsSearch: any[] = [];

  loading=false;
  modalNoUser: NgbModalRef;
  errorMessage=false;
  deleteMessage=false;

  constructor(private _device: DeviceService, private _router: Router, private _modal: ModalService, private _user: UserService, private translate: TranslateService) { }

  ngOnInit(): void {

  }

  searchBySerial(){
    this.deleteMessage=false;
    this.errorMessage=false;
    this.loading=true;
    this.resultsSearch = [];

    if(this.serialSearch!=''){
      this._device.getDeviceInfo(this.serialSearch)
      .subscribe({
        next: (data) => {
          console.log(data);
          this.resultsSearch.push(data);
          this.userSearch=data.user_build;
          this.loading=false;
        },
        error: (err) => {
          this.loading=false;
          this.errorMessage=true;
        }
      });
    }

  }

  searchByUser(){
    this.errorMessage=false;
    this.loading=true;
    if(this.userSearch!=''){
      this._device.getDevicesByUser(this.userSearch)
      .subscribe({
        next: (data) => {
          console.log(data);
          this.resultsSearch=data;
          this.loading=false;

        },
        error: (err) => {
          this.loading=false;
          this.errorMessage=true;
        }
      });
    }

  }

  navigateDevice(url, device, subpath?: string){
    //this._device.setUserDevice(this.userSearch);
    setTimeout(() => {
      subpath ? this._router.navigate([url, device, subpath]) : this._router.navigate([url, device]);
    }, 500);
  }

  resetHistorics(deviceSerial: string): void {
    this.translate.get('resetHistoricsByDevice', { device: deviceSerial }).subscribe((message: string) => {
      if (!confirm(message)) {
        return;
      }

      this._device.resetHistoricsByDevice(deviceSerial)
        .subscribe({
          next: (response: HttpResponse<Blob>) => {
            const downloadURL = window.URL.createObjectURL(response.body);
            const link = document.createElement('a');
            link.href = downloadURL;
            link.download = `historics_${deviceSerial}.xlsx`;
            link.click();
            this.deleteMessage = true;
          },
          error: (error) => {
            console.error('Error resetting historics:', error);
          }
        });
    });
  }

  unlinkDevice(userToDelete: string, device: string){
    this.translate.get('chgVincBodyCard', { user: userToDelete }).subscribe((message: string) => {
      if (!confirm(message)) {
        return;
      }
      this._device.unlinkUserFromCharger(userToDelete, device)
        .subscribe({
          next: () => {
            this.searchByUser();
          },
          error: (error) => {
            console.error('Error unlinking device:', error);
          }
        });
    });

  }

  isAncFamilyDevice(device: { sub_type?: string; serial?: string }): boolean {
    return isAncFamilyDevice(device);
  }
}
